exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card{\n  border-radius: 3px;\n  background: #FFFFFF;\n  margin-top: 1%;\n  margin-bottom: 3%;\n}\n\n.card-index {\n  display: block-inline;\n  float: left;\n  margin-bottom: 1%;\n  margin-left: 1%;\n}\n\n.card-index-right {\n  display: block-inline;\n  float: right;\n  margin-top: 1%;\n  margin-bottom: 1%;\n  margin-right: 22.5%;\n}\n\n.title-card{\n  background: #673AB7;\n  height: 35px;\n}\n\n.title-card span{\n  color: #FFFFFF;\n  font-size: 1.5em;\n  margin-left: 1%;\n  vertical-align: bottom;\n  position: relative;\n  top: 28%;\n  left: 0;\n}\n\n.title-card span a{\n  color: #FFFFFF;\n  font-size: 1em;\n  margin-top: 5%;\n  margin-left: 1%;\n  text-decoration: none;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.title-logo{\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/card.css
// module id = 241
// module chunks = 0